"use strict";

exports.__esModule = true;
var _HistoricalPartCountPopup = require("./HistoricalPartCountPopup");
Object.keys(_HistoricalPartCountPopup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HistoricalPartCountPopup[key]) return;
  exports[key] = _HistoricalPartCountPopup[key];
});
var _HistoricalPartCountShiftPopup = require("./HistoricalPartCountShiftPopup");
Object.keys(_HistoricalPartCountShiftPopup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HistoricalPartCountShiftPopup[key]) return;
  exports[key] = _HistoricalPartCountShiftPopup[key];
});